import React, { useEffect, useState } from "react";
import Navbar from "../components/partial/Navbar";
import Footer from "../components/partial/Footer";
import Banner from "../components/Banner";
import PackageCard from "../components/card/PackageCard";
import { Link } from "react-router-dom";
import BlogCard from "../components/card/BlogCard";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  useAllPackageQuery,
  useCombinedpackageQuery,
} from "../../redux/API/PackageApi";

import { useAllBlogQuery } from "../../redux/API/BlogApi";
import { useAllThemeQuery } from "../../redux/API/ThemeApi";

import {
  API_URL,
  blogImgUrl,
  categoryapi,
  destinationImgUrl,
  ImgUrl,
  packageImgUrl,
  themeImgUrl,
} from "../../constant";

import { useAllDestinationQuery } from "../../redux/API/DestinationApi";
import placeholderImg from "../asset/ghumneplaceholder.jpg";

import axios from "axios";
const Home = () => {
  const [categories, setCategries] = useState("");
  console.log(categories, "caatttt");

  const { data: packagesData } = useAllPackageQuery();
  const { data: blogData } = useAllBlogQuery();
  const { data: themeData } = useAllThemeQuery();
  const { data: destinationData } = useAllDestinationQuery();
  const { data: combinedData, isLoading, error } = useCombinedpackageQuery();

  useEffect(() => {
    AOS.init({
      delay: 100,
      duration: 600,
      easing: "ease",
      once: false,
      mirror: false,
    });
  }, []);
  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await axios.get(`${API_URL}${categoryapi}`);
        setCategries(response?.data?.data);
      } catch (error) {}
    };
    fetchPackages();
  }, []);

  return (
    <>
      <Navbar />
      <Banner />
      <section className="theme container mt-5 overflow-hidden pb-3">
        <h2 className="mt-4 mb-3">Theme</h2>
        <div className="row gy-3">
          <Swiper
            slidesPerView={1}
            spaceBetween={10}
            className="mySwiper"
            breakpoints={{
              640: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 10,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 10,
              },
            }}
          >
            {themeData?.themes &&
              themeData?.themes?.length > 0 &&
              themeData?.themes?.slice(0, 4)?.map?.((theme) => (
                <div
                  key={theme._id}
                  className="col-lg-3 col-md-6"
                  data-aos="fade-up"
                >
                  <SwiperSlide>
                    <Link
                      to={`/theme/${theme.slug}`}
                      className="text-decoration-none"
                    >
                      <div className="theme-card position-relative rounded-3 overflow-hidden">
                        <img
                          src={`${ImgUrl}${themeImgUrl}${theme.image}`}
                          alt={theme.name}
                          onError={(e) => (e.target.src = placeholderImg)}
                          className="w-100 h-100 object-fit-cover"
                        />
                        <h4 className="position-absolute bottom-0 left-0 text-center text-white fw-semibold fs-6 theme-bg">
                          {theme.name}
                        </h4>
                      </div>
                    </Link>
                  </SwiperSlide>
                </div>
              ))}
          </Swiper>
          {themeData?.themes && themeData.themes.length > 0 && (
            <div className="col-12 mt-5 text-center">
              <Link
                to="/theme"
                className="heading px-5 fw-medium py-2 rounded-2 text-white text-decoration-none"
                data-aos="fade-up"
              >
                Explore More Themes
              </Link>
            </div>
          )}
        </div>
      </section>

      <section className="theme container mt-5 overflow-hidden pb-3">
        <h2 className="mt-4 mb-3">Destination</h2>
        <div className="row gy-3">
          <Swiper
            slidesPerView={1}
            spaceBetween={10}
            className="mySwiper"
            breakpoints={{
              640: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 10,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 10,
              },
            }}
          >
            {destinationData?.destinations &&
              destinationData?.destinations?.length > 0 &&
              destinationData.destinations.map((destinations) => (
                <div
                  key={destinations._id}
                  className="col-lg-3 col-md-6"
                  data-aos="fade-up"
                >
                  <SwiperSlide>
                    <Link to={`/destination/${destinations.slug}`}>
                      <div className="theme-card position-relative rounded-3 overflow-hidden">
                        <img
                          src={`${ImgUrl}${destinationImgUrl}${destinations.image}`}
                          // onError={(e) => (e.target.src = placeholderImg)}
                          alt={destinations.name}
                          className="w-100 h-100 object-fit-cover"
                        />
                        <h4 className="position-absolute bottom-0 left-0 text-center text-white fw-semibold fs-6 theme-bg">
                          {destinations.name}
                        </h4>
                      </div>
                    </Link>
                  </SwiperSlide>
                </div>
              ))}
          </Swiper>
          {destinationData?.destinations &&
            destinationData.destinations.length > 0 && (
              <div className="col-12 mt-5 text-center">
                <Link
                  to="/destination"
                  className="heading px-5 fw-medium py-2 rounded-2 text-white text-decoration-none"
                  data-aos="fade-up"
                >
                  Explore More Destinations
                </Link>
              </div>
            )}
        </div>
      </section>

      <section className="container mt-5">
        <h2 className="mb-3">Top Recommended Packages</h2>
        <div className="row gy-3">
          {isLoading ? (
            <p className="text-center">Loading...</p>
          ) : error ? (
            <p className="text-center">Error fetching data!</p>
          ) : combinedData && combinedData?.data?.length > 0 ? (
            <div>
              <div className="row gy-3">
                {combinedData &&
                  combinedData?.data?.slice(0, 4)?.map((packageItem) => (
                    <div key={packageItem?._id} className="col-lg-3">
                      <Link
                        to={`/packages/detail/${packageItem?.slug}`}
                        className="text-decoration-none text-unset"
                      >
                        <PackageCard
                          title={
                            packageItem?.name
                          }
                          location={packageItem?.location}
                          days={`${packageItem?.days}D / ${
                            packageItem?.days - 1
                          }N`}
                          price={"On Demand"}
                          slug={packageItem?.slug} // ✅ Pass this!
                          img={`${ImgUrl}${packageImgUrl}${
                            packageItem?.images && packageItem?.images[0]
                          }`}
                          itinerary={packageItem?.itinerary}
                          otherInfo={packageItem?.otherInfo}
                          overview={packageItem?.overview}
                          alt="Package Image"
                        />
                      </Link>
                    </div>
                  ))}
              </div>
            </div>
          ) : (
            <p className="text-center">No Recommended Packages Available</p>
          )}
        </div>
      </section>

      <section className="top-location container mt-3 pb-3 overflow-hidden">
        {/* Grouping packages by their type (Domestic, International) */}
        {packagesData &&
          packagesData?.data.length > 0 &&
          Object.entries(
            packagesData?.data.reduce((groups, pkg) => {
              const type = pkg?.user?.ptypeId?.name || "Others"; // Package type (Domestic/International)

              if (!groups[type]) {
                groups[type] = []; // Initialize the group if it doesn't exist
              }

              groups[type].push(pkg); // Add package to the respective group

              return groups;
            }, {})
          ).map(([groupName, groupPackages]) => {
            return (
              <>
                <div key={groupName}>
                  {/* Displaying the heading for each group */}
                  <h2 className="mt-4 mb-2" data-aos="fade-up">
                    {groupName} Packages
                  </h2>

                  {/* Displaying the packages in a flex layout */}
                  <div
                    className="row gy-3"
                    style={{ display: "flex", flexWrap: "wrap" }}
                  >
                    {groupPackages?.slice(0, 4)?.map((pkg) => (
                      <>
                        <div
                          className="col-lg-3"
                          data-aos="fade-up"
                          key={pkg._id}
                        >
                          <Link
                            to={`/packages/detail/${pkg?.user?.slug}`}
                            className="text-decoration-none text-unset"
                          >
                            <PackageCard
                              title={
                                pkg?.user?.name
                              }
                              location={pkg?.user?.location}
                              price={"On Demand"}
                              img={`${ImgUrl}${packageImgUrl}${pkg.images[0]}`}
                              slug={pkg?.user?.slug} 
                              alt="Package Image"
                              days={`${pkg?.user?.days} D/ ${
                                pkg?.user?.days - 1
                              } N`}
                            />
                          </Link>
                        </div>
                      </>
                    ))}
                  </div>
                </div>
                <div className="col-12 mt-5 text-center">
                  <div className="d-inline-block m-2">
                    <Link
                      to={`/packages/${groupPackages[0]?.user?.ptypeId?._id}`}
                      className="heading px-5 fw-medium py-2 rounded-2 text-white text-decoration-none"
                      data-aos="fade-up"
                    >
                      Explore More Packages
                    </Link>
                  </div>
                </div>
              </>
            );
          })}
      </section>

      <section className="blog_section py-5 mt-5 overflow-hidden">
        <div className="container">
          <h2 className="fw-semibold" data-aos="fade-up">
            Tales of our Travellers : Blogs
          </h2>
          <div className="row mt-3 gy-3">
            {blogData && blogData.data.allBlogs.length > 0 ? (
              blogData?.data?.allBlogs?.slice(0, 4)?.map((blog) => (
                <div
                  key={blog._id}
                  className="col-lg-3 col-md-6"
                  data-aos="fade-up"
                >
                  <Link
                    to={`/blogs/${blog.slug}`}
                    className="text-decoration-none text-unset "
                  >
                    <BlogCard
                      title={blog.title}
                      desc={
                        blog.description
                          ? blog.description
                          : "Read more about this amazing journey"
                      }
                      img={`${ImgUrl}${blogImgUrl}${blog.image}`}
                      slug={blog?.slug}
                      border={"green"}
                    />
                  </Link>
                </div>
              ))
            ) : (
              <p className="text-center">No Blogs Available</p>
            )}

            <div className="col-12 mt-5 text-center">
              <Link
                to="/blogs"
                className="bg-white text-black px-5 fw-medium py-2 rounded-2 text-decoration-none"
              >
                Explore More Blogs
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="top-location container mt-5 overflow-hidden">
        <h2 className="mt-4 fw-semibold" data-aos="fade-up">
          Testimonials
        </h2>
        <div className="row">
          <Swiper
            style={{
              "--swiper-navigation-color": "#000",
            }}
            slidesPerView={1}
            spaceBetween={20}
            breakpoints={{
              640: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 20,
              },
            }}
            className="mySwiper py-4"
          >
            <SwiperSlide>
              <div className="col-12" data-aos="fade-up">
                <div className="testimonial_card bg-white p-4  rounded-3">
                  <h6 className="mb-0">Ranjit Sharma</h6>
                  <p className="text-muted">Business Owner</p>
                  <p className="text-muted">
                    It is a dream destination for travelers of all kinds, with
                    every corner smelling of the quintessential Singapore:
                    excitement, exuberance, and exploration.
                  </p>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="col-12" data-aos="fade-up">
                <div className="testimonial_card bg-white p-4  rounded-3">
                  <h6 className="mb-0">Ranjit Sharma</h6>
                  <p className="text-muted">Business Owner</p>
                  <p className="text-muted">
                    It is a dream destination for travelers of all kinds, with
                    every corner smelling of the quintessential Singapore:
                    excitement, exuberance, and exploration.
                  </p>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="col-12" data-aos="fade-up">
                <div className="testimonial_card bg-white p-4  rounded-3">
                  <h6 className="mb-0">Ranjit Sharma</h6>
                  <p className="text-muted">Business Owner</p>
                  <p className="text-muted">
                    It is a dream destination for travelers of all kinds, with
                    every corner smelling of the quintessential Singapore:
                    excitement, exuberance, and exploration.
                  </p>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="col-12" data-aos="fade-up">
                <div className="testimonial_card bg-white p-4  rounded-3">
                  <h6 className="mb-0">Ranjit Sharma</h6>
                  <p className="text-muted">Business Owner</p>
                  <p className="text-muted">
                    It is a dream destination for travelers of all kinds, with
                    every corner smelling of the quintessential Singapore:
                    excitement, exuberance, and exploration.
                  </p>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="col-12">
                <div className="testimonial_card bg-white p-4  rounded-3">
                  <h6 className="mb-0">Ranjit Sharma</h6>
                  <p className="text-muted">Business Owner</p>
                  <p className="text-muted">
                    It is a dream destination for travelers of all kinds, with
                    every corner smelling of the quintessential Singapore:
                    excitement, exuberance, and exploration.
                  </p>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Home;
